import up from "./up";

export const chevron = {
  "chevron/up": up,
};
